// zoom-sync-to-main.js
(() => {
    const VARIANT_EVENTS = ['variant:update', 'theme:variant:update', 'change:variant'];
  
    function selectAll(root, sel) { return Array.from(root.querySelectorAll(sel)); }
  
    function getVisibleIdsFromMain(gallery) {
      // Pull media-ids from the rebuilt scroller (your main filter already rebuilt it)
      const scroller = gallery.querySelector('slideshow-component [ref="scroller"]');
      if (!scroller) return null;
      const ids = selectAll(scroller, '[ref="slides[]"] .product-media[data-media-id]')
        .map(n => n.getAttribute('data-media-id'))
        .filter(Boolean);
      return ids.length ? new Set(ids) : null;
    }
  
    function filterZoomToIds(gallery) {
      const zoom = gallery.querySelector('zoom-dialog');
      if (!zoom) return;
  
      const dialogEl = zoom.querySelector('dialog');
      const ids = getVisibleIdsFromMain(gallery);
      if (!ids || !dialogEl) return;
  
      const slideEls = selectAll(zoom, '.dialog-zoomed-gallery > .product-media-container');
      const thumbEls = selectAll(zoom, '.dialog-thumbnails-list__thumbnail');
  
      const visibleIdx = [];
      slideEls.forEach((li, i) => {
        const media = li.querySelector('.product-media[data-media-id]');
        const ok = media && ids.has(media.getAttribute('data-media-id'));
        li.toggleAttribute('hidden', !ok);
        li.setAttribute('aria-hidden', ok ? 'false' : 'true');
        if (ok) visibleIdx.push(i);
      });
  
      thumbEls.forEach((btn, i) => {
        const show = visibleIdx.includes(i);
        btn.toggleAttribute('hidden', !show);
        btn.setAttribute('aria-selected', 'false');
        btn.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
  
      // Focus/scroll first visible slide to ensure correct start state
      if (visibleIdx.length) {
        const first = visibleIdx[0];
        thumbEls[first]?.setAttribute('aria-selected', 'true');
        // If your zoom dialog internally listens to clicks, this triggers its own logic cleanly:
        try { thumbEls[first]?.click?.(); } catch (_) {}
        // Fallback scroll if the component ignores programmatic click:
        slideEls[first]?.scrollIntoView?.({ block: 'nearest', inline: 'start' });
      }
    }
  
    function wireGallery(gallery) {
      const zoom = gallery.querySelector('zoom-dialog');
      if (!zoom || zoom.dataset.syncWired) return;
      zoom.dataset.syncWired = 'true';
  
      const dialogEl = zoom.querySelector('dialog');
      if (!dialogEl) return;
  
      // Run on dialog open
      const onOpen = () => {
        if (dialogEl.hasAttribute('open')) filterZoomToIds(gallery);
      };
  
      // <dialog> fires 'toggle' and flips [open]; cover both
      zoom.addEventListener?.('toggle', onOpen);
      new MutationObserver(onOpen).observe(dialogEl, { attributes: true, attributeFilter: ['open'] });
  
      // Keep in sync while open if variant changes
      VARIANT_EVENTS.forEach(evt => {
        document.addEventListener(evt, () => {
          if (dialogEl.hasAttribute('open')) filterZoomToIds(gallery);
        });
      });
    }
  
    // Wire all media galleries on the page
    const galleries = document.querySelectorAll('media-gallery');
    galleries.forEach(wireGallery);
  
    // If sections can be re-rendered dynamically, observe new galleries
    const mo = new MutationObserver((muts) => {
      muts.forEach(m => {
        m.addedNodes && m.addedNodes.forEach((n) => {
          if (n.nodeType === 1) {
            if (n.matches?.('media-gallery')) wireGallery(n);
            n.querySelectorAll?.('media-gallery').forEach(wireGallery);
          }
        });
      });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  })();
  